import script from "./information-mgmt-edit.vue?vue&type=script&lang=tsx&setup=true"
export * from "./information-mgmt-edit.vue?vue&type=script&lang=tsx&setup=true"

import "./information-mgmt-edit.vue?vue&type=style&index=0&id=fb55a982&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb55a982"]])

export default __exports__